import { Tag, useTranslation } from '@nextgen-web-framework/all';
import { ProductCardComponent, CardType } from '../Molecules';
import type { ProductCardTagProps } from '../Molecules/ProductCardComponent/types/propsTypes';
import styles from './CheckoutCard.module.scss';
import type { CheckoutCardPropsTypes } from './types/propsTypes';

const CheckoutCard = (props: CheckoutCardPropsTypes) => {
  const t = useTranslation();
  const {
    brandName,
    productName,
    link,
    alt,
    productId,
    showProductId = false,
    productSize,
    productQuantity,
    derivedAvailabilityStatus,
    dateSubText,
    productPrice,
    currency,
    strikethroughPrice,
    isBundle,
    minPrice,
    maxPrice,
    pointValue,
    businessVolume,
    className = '',
    availabilityStatus,
    variantName,
    handleDropdown,
    tags,
    orderInfoText,
    showLinkForProductCard,
    productType,
    isUnavailable,
    unavailableText,
    showError,
    showZeroAsFree = true,
    showPropertiesCollection,
    productRetailPrice,
    minRetailPrice,
    maxRetailPrice,
    firstAvailableFutureDate = '',
    showPrefix = false,
    itemIdPrefixText = t('product.common.item'),
    showItemIdPrefixText = false,
  } = props;

  const getProductTags = () => (
    <>
      {tags && tags?.length > 0 && (
        <div className={styles['productTag-container']}>
          {tags?.map((tag: ProductCardTagProps) => (
            <Tag
              text={tag.text}
              key={tag.icon?.iconName}
              className={styles['productTag']}
              icon={tag.icon}
              style={tag.style}
              theme={tag.theme}
            />
          ))}
        </div>
      )}
    </>
  );

  return (
    <div className={`${styles['cpw-checkout-card-hoc']} ${className}`} data-testid="cpw-checkout-card-hoc-test-id">
      {getProductTags()}
      <ProductCardComponent
        brandName={brandName}
        productName={productName}
        link={link}
        alt={alt}
        productId={productId}
        showProductId={showProductId}
        productSize={productSize}
        derivedAvailabilityStatus={derivedAvailabilityStatus}
        productPrice={productPrice}
        currency={currency}
        cardType={CardType.CHECKOUT}
        strikethroughPrice={strikethroughPrice}
        minPrice={minPrice}
        maxPrice={maxPrice}
        isBundle={isBundle}
        pointValue={pointValue}
        businessVolume={businessVolume}
        productQuantity={productQuantity}
        dateSubText={dateSubText}
        availabilityStatus={availabilityStatus}
        variantName={variantName}
        handleDropdown={handleDropdown}
        orderInfoText={orderInfoText}
        showLinkForProductCard={showLinkForProductCard}
        productType={productType}
        isUnavailable={isUnavailable}
        unavailableText={unavailableText}
        showError={showError}
        showZeroAsFree={showZeroAsFree}
        showPropertiesCollection={showPropertiesCollection}
        productRetailPrice={productRetailPrice}
        minRetailPrice={minRetailPrice}
        maxRetailPrice={maxRetailPrice}
        firstAvailableFutureDate={firstAvailableFutureDate}
        showPrefix={showPrefix}
        itemIdPrefixText={showItemIdPrefixText ? itemIdPrefixText : ''}
      />
    </div>
  );
};

export default CheckoutCard;
export type { CheckoutCardPropsTypes };
